import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCompanyDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(["companyDelete"], async (companyId: number) => apiContext.companyApis.deleteCompany(companyId), {
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
